<template>
  <div class="pagination-box" v-show="total > 0">
    <el-pagination
      @size-change="pageSizeChanged"
      @current-change="config.pageIndexChanged"
      :current-page.sync="pageNumber"
      :page-size="config.pageSize || 10"
      :page-sizes="[5, 10, 15, 20, 50, 100]"
      :layout="config.layout || 'prev, pager, next, slot'"
      :total="total || 0"
      :style="config.styles || ''">
      <span class="fr slot">一共 {{total}} 行, 当前 {{pageNumber}}/{{getPages}} 页</span>
    </el-pagination>
  </div>
</template>

<script>
/*
  created by zxl
  符合UI要求的分页空间，接受一个对象作为初始配置项，例如
  config: {
    pageNumber: 1,
    pageSize: 10,
    total: 100,
    pageIndexChanged: func,
    pageSizeChanged: func,
    layout: ''
  }
  可参照../../pages/enterprise/shops/list.vue
*/
export default {
  props: {
    config: {
      type: Object,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  computed: {
    getPages () {
      let ps = (this.config.pageSize || 10)
      let pages = Math.floor(this.total / ps)
      if ((this.total > ps && this.total % ps > 0) || pages === 0) {
        pages++
      }
      return pages
    }
  },
  watch: {
    config () {
      this.pageNumber = this.config.pageNumber || 1
    }
  },
  data () {
    return {
      pages: 0,
      pageNumber: this.config.pageNumber || 1
    }
  },
  methods: {
    pageSizeChanged (ps) {
      this.pageNumber = 1
      if (this.config.pageSizeChanged) {
        this.config.pageSizeChanged(ps)
      }
    }
  }
}
</script>

<style lang="scss">
  .pagination-box {
    & .el-pagination{
      clear: both;
      text-align: center;
      background-color: #fff;
      height: 40px;
      padding-top: 15px;
      & .el-pagination__jump {
        margin: 0;
        float: left;
      }
      & .el-pagination__sizes, & .el-pagination__total {
        float: right;
      }
      & .number, & .btn-next, & .btn-prev {
        border-radius: 2px;
        background-color: #ffffff;
        border: solid 1px #dcdcdc;
        margin-left: 10px;
        font-size: 12px;
        color: #333;
        font-weight: normal;
      }
      & .number.active {
        background-color: #409eff;
        border: solid 1px #409eff;
        color: #fff;
      }
      & .btn-quicknext, & .btn-quickprev {
        margin-left: 10px;
        border: none;
        background: transparent;
      }
      & button[disabled='disabled'] {
        background-color: #ebebeb;
        border: solid 1px #dcdcdc;
      }
      & .slot {
        font-weight: normal;
        margin-right: 10px;
      }
    }
  }
</style>
